(function autoCloseDetails() {
  document.addEventListener('click', function (event) {
    const detailsToClose = [...document.querySelectorAll('details[data-auto-close-details][open]')].filter(
      (element) => {
        const closingOn = window.innerWidth < 750 ? 'mobile' : 'desktop';
        return (
          element.getAttribute('data-auto-close-details')?.includes(closingOn) &&
          !(event.target instanceof Node && element.contains(event.target))
        );
      }
    );

    for (const detailsElement of detailsToClose) detailsElement.removeAttribute('open');
  });
})();

(function initDomstadScrollReveal() {
  if (!('IntersectionObserver' in window)) return;
  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

  const main = document.querySelector('#MainContent');
  if (!main) return;

  const style = document.createElement('style');
  style.id = 'dc-scroll-reveal-styles';
  style.textContent = `
    .dc-reveal-section {
      opacity: 0;
      transform: translate3d(0, 14px, 0);
      transition:
        opacity 560ms cubic-bezier(0.22, 1, 0.36, 1),
        transform 680ms cubic-bezier(0.22, 1, 0.36, 1);
      will-change: opacity, transform;
    }

    .dc-reveal-section.is-visible {
      opacity: 1;
      transform: translate3d(0, 0, 0);
      will-change: auto;
    }

    @media (prefers-reduced-motion: reduce) {
      .dc-reveal-section {
        opacity: 1;
        transform: none;
        transition: none;
      }
    }
  `;
  document.head.appendChild(style);

  const viewportHeight = () => window.visualViewport?.height || window.innerHeight || document.documentElement.clientHeight;

  const observer = new IntersectionObserver(
    (entries) => {
      for (const entry of entries) {
        if (!entry.isIntersecting) continue;
        entry.target.classList.add('is-visible');
        observer.unobserve(entry.target);
      }
    },
    {
      threshold: 0.08,
      rootMargin: '0px 0px -7% 0px',
    }
  );

  function prepareSection(section, forceSkip) {
    if (!(section instanceof HTMLElement)) return;
    if (section.dataset.dcRevealReady === 'true') return;

    section.dataset.dcRevealReady = 'true';

    const rect = section.getBoundingClientRect();
    const initiallyVisible = rect.bottom > 0 && rect.top < viewportHeight() * 1.05;

    if (forceSkip || initiallyVisible) return;

    section.classList.add('dc-reveal-section');
    observer.observe(section);
  }

  const sections = Array.from(main.children).filter((element) => element.classList.contains('shopify-section'));
  sections.forEach((section, index) => prepareSection(section, index === 0));

  document.addEventListener('shopify:section:load', (event) => {
    prepareSection(event.target, false);
  });
})();
